export const CheckUnsubscribeRequestInitial = {
  status: false,
  reasonForRejection: "",
};

